/**
 * The bearer token for this page load, obtained by exchanging the swap token
 * the server rendered into the document. It is deliberately held in memory
 * only: persisting it, or letting the server inline it into the HTML, would
 * leave the credential in browser caches, CDN edges and RUM session replays.
 */
let bearerToken: string | undefined = undefined;

export const setUserBearerToken = (token: string): void => {
  bearerToken = token;
};

export const getUserBearerToken = (): string | undefined => bearerToken;
